import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'video.js/dist/video-js.css'

import ErrorMessageArea from './components/ErrorMessageArea.vue'
import PageMessageArea from './components/PageMessageArea.vue'
import PageTitle from './components/PageTitle.vue'
import PageHeader from './components/PageHeader.vue'
import SearchResultHeader from './components/SearchResultHeader.vue'
import ErrorMessage from './components/ErrorMessage.vue'
import ButtonNormal from './components/ButtonNormal.vue'
import ButtonMain from './components/ButtonMain.vue'
import ButtonDelete from './components/ButtonDelete.vue'
import ButtonImg from './components/ButtonImg.vue'
import RequiredItem from './components/RequiredItem.vue'
import PageControl from './components/PageControl.vue'
import Pagination from './components/Pagination.vue'
import DatePickerTE from './components/DatePickerTE.vue'
import InputText from './components/InputText.vue'
import InputSelect from './components/InputSelect.vue'
import SujectName from './components/SujectName.vue'
import Dialog from './components/Dialog.vue'
import VueQuillEditor from 'vue-quill-editor'
import Treeselect from '@riophae/vue-treeselect'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import FilterableDropdown from './components/FilterableDropdown.vue'
import ModalDialog from './components/ModalDialog.vue'
import TreeNode from './components/TreeNode.vue'
import TreeView from './components/TreeView.vue'
import IssueCandidateDialog from './components/popup/IssueCandidateDialog.vue'
import LoadingByOCRDialog from './components/popup/LoadingByOCRDialog.vue'
import ListOfOCRReadFilesDialog from './components/popup/ListOfOCRReadFilesDialog.vue'
import DownloadDialog from './components/popup/DownloadDialog.vue'
import CourtEntryAssistanceDialog from './components/popup/CourtEntryAssistanceDialog.vue'
import CheckOCRReadFileDialog from './components/popup/CheckOCRReadFileDialog.vue'
import CheckOCRReadFileDialogZS from './components/popup/CheckOCRReadFileDialogZS.vue'
import IncidentsCompilationDialog from './components/popup/IncidentsCompilationDialog.vue'
import FileDeletionConfirmationRequestDialog from './components/popup/FileDeletionConfirmationRequestDialog.vue'
import CaseSheetPrintingDialog from './components/popup/CaseSheetPrintingDialog.vue'
import InputSelectTENew from './components/popup/InputSelectTENew.vue'
import InputAuxiliaryPartscopy from './components/popup/InputAuxiliaryPartscopy.vue'
import RegistrationConfirmation from './components/popup/RegistrationConfirmation.vue'
import DepartmentCharge from './components/popup/DepartmentCharge.vue'
import ExecutionDialog from './components/popup/ExecutionDialog.vue'
import CourtInputAssistance from './components/popup/CourtInputAssistance.vue'
import AttachmentSelectionDialog from './components/popup/AttachmentSelectionDialog.vue'
import WarekiSelect from './components/WarekiSelect.vue'
import Print from 'vue-print-nb'
//vue-js-modal
import VModal from 'vue-js-modal'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import filter from './utils/filters.js'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Print)
Vue.use(VueQuillEditor)
Vue.use(VueDOMPurifyHTML,{
  hooks: {
    afterSanitizeAttributes: (currentNode) => {
      if('target' in currentNode){
        currentNode.setAttribute("target","_blank");
      }
    }  
  }
})
//vue-js-modal
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: true } })
Vue.component("ErrorMessageArea", ErrorMessageArea)
Vue.component("PageMessageArea", PageMessageArea)
Vue.component("PageTitle", PageTitle)
Vue.component("PageHeader", PageHeader)
Vue.component("SearchResultHeader", SearchResultHeader)
Vue.component("ErrorMessage", ErrorMessage)
Vue.component("ButtonNormal", ButtonNormal)
Vue.component("ButtonMain", ButtonMain)
Vue.component("ButtonDelete", ButtonDelete)
Vue.component("ButtonImg", ButtonImg)
Vue.component("RequiredItem", RequiredItem)
Vue.component("PageControl", PageControl)
Vue.component("Pagination", Pagination)
Vue.component("DatePickerTE", DatePickerTE)
Vue.component("InputText", InputText)
Vue.component("InputSelect", InputSelect)
Vue.component("WarekiSelect", WarekiSelect)
Vue.component("SujectName", SujectName)
Vue.component("Dialog", Dialog)
Vue.component("FilterableDropdown", FilterableDropdown)
Vue.component("ModalDialog", ModalDialog)
Vue.component("TreeNode", TreeNode)
Vue.component("TreeView", TreeView)
Vue.component("IssueCandidateDialog", IssueCandidateDialog)
Vue.component("LoadingByOCRDialog", LoadingByOCRDialog)
Vue.component("ListOfOCRReadFilesDialog", ListOfOCRReadFilesDialog)
Vue.component("DownloadDialog", DownloadDialog)
Vue.component("CourtEntryAssistanceDialog", CourtEntryAssistanceDialog)
Vue.component("CheckOCRReadFileDialog", CheckOCRReadFileDialog)
Vue.component("CheckOCRReadFileDialogZS", CheckOCRReadFileDialogZS)
Vue.component("IncidentsCompilationDialog", IncidentsCompilationDialog)
Vue.component("FileDeletionConfirmationRequestDialog", FileDeletionConfirmationRequestDialog)
Vue.component("CaseSheetPrintingDialog", CaseSheetPrintingDialog)
Vue.component("InputSelectTENew", InputSelectTENew)
Vue.component("InputAuxiliaryPartscopy", InputAuxiliaryPartscopy)
Vue.component("RegistrationConfirmation", RegistrationConfirmation)
Vue.component("DepartmentCharge", DepartmentCharge)
Vue.component("Treeselect", Treeselect)
Vue.component("ExecutionDialog", ExecutionDialog)
Vue.component("CourtInputAssistance", CourtInputAssistance)
Vue.component("AttachmentSelectionDialog", AttachmentSelectionDialog)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


//stopscroll
Vue.prototype.stopScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)
}

//canscroll
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''
  document.removeEventListener('touchmove', mo, false)
}

// 文字列フォーマット
Vue.prototype.$stringFormat = function (formatted, ...args) {
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi')
    formatted = formatted.replace(regexp, args[i])
  }
  return formatted
}